"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const ClockIcon = ({
  color,
  title,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", { ...otherProps,
  width: "23",
  height: "23",
  viewBox: "0 0 23 23",
  xmlns: "http://www.w3.org/2000/svg",
  children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    children: title
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      transform: "translate(-527.000000, -344.000000)",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        transform: "translate(528.000000, 345.000000)",
        fill: color,
        fillRule: "nonzero",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M10.5,-1 C16.8512746,-1 22,4.14872538 22,10.5 C22,16.8512746 16.8512746,22 10.5,22 C4.14872538,22 -1,16.8512746 -1,10.5 C-1,4.14872538 4.14872538,-1 10.5,-1 Z M10.5,1 C5.25329488,1 1,5.25329488 1,10.5 C1,15.7467051 5.25329488,20 10.5,20 C15.7467051,20 20,15.7467051 20,10.5 C20,5.25329488 15.7467051,1 10.5,1 Z M10.5,3 C11.0128358,3 11.4355072,3.38604019 11.4932723,3.88337887 L11.5,4 L11.5,11 C11.5,11.2018526 11.4389457,11.3979878 11.326288,11.5632519 L11.2525767,11.6585046 L7.75257669,15.6585046 C7.38889464,16.0741412 6.75713202,16.1162587 6.34149539,15.7525767 C5.95783081,15.4168702 5.89243104,14.85274 6.17068553,14.4410277 L6.24742331,14.3414954 L9.5,10.623 L9.5,4 C9.5,3.48716416 9.88604019,3.06449284 10.3833789,3.00672773 L10.5,3 Z"
        })
      })
    })
  })]
});

ClockIcon.defaultProps = {
  color: 'currentColor',
  title: undefined
};
var _default = ClockIcon;
exports.default = _default;